export default __webpack_public_path__ + "static/media/MIUSEE_Beauty_logo.af92ea0c.png";